'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadVideoError = exports.updateVideoList = exports.updateVideoFilter = exports.rateVideo = exports.loadUpcomingVideos = exports.loadVideoStacks = exports.loadVideoCollection = exports.loadOnDemandVideos = exports.loadVideos = exports.filterActions = exports.FILTERSET_NAME = exports.UPDATE_VIDEO_LIST = exports.UPDATE_VIDEO_FILTER = exports.LOAD_VIDEO_ERROR = exports.LOAD_VIDEO_COLLECTION = exports.LOAD_ONDEMAND_VIDEOS = exports.RATE_VIDEO = exports.LOAD_VIDEOS = exports.LOAD_UPCOMING_VIDEOS = exports.LOAD_VIDEO_STACKS = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.rateVideoRequest = rateVideoRequest;
exports.onModalClose = onModalClose;
exports.doUpdateVideoFilter = doUpdateVideoFilter;
exports.doUpdateVideoList = doUpdateVideoList;
exports.doLoadOnDemandVideos = doLoadOnDemandVideos;
exports.doLoadVideoCollection = doLoadVideoCollection;
exports.doLoadVideos = doLoadVideos;
exports.doLoadVideoStacks = doLoadVideoStacks;
exports.doLoadUpcomingVideos = doLoadUpcomingVideos;
exports.doRateVideo = doRateVideo;
exports.watchVideos = watchVideos;
exports.watchOnDemandVideos = watchOnDemandVideos;
exports.watchVideoCollection = watchVideoCollection;
exports.watchLoadUpcomingVideos = watchLoadUpcomingVideos;
exports.watchLoadVideos = watchLoadVideos;
exports.watchUpdateVideoList = watchUpdateVideoList;

var _cookie = require('cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _sagaTools = require('@classpass/saga-tools');

var _helpers = require('redux/saga/helpers');

var _reactRouterRedux = require('react-router-redux');

var _effects = require('redux-saga/effects');

var _bound = require('redux/saga/entities/bound');

var _selectors = require('redux/saga/selectors');

var _rating = require('redux/modules/rating');

var _modals = require('redux/modules/modals');

var _video = require('constants/video');

var _filtersets = require('redux/modules/filtersets');

var _filters = require('redux/saga/helpers/filters');

var _Subscription = require('derivers/Subscription');

var _Subscription2 = _interopRequireDefault(_Subscription);

var _Banners = require('features/Banners/Banners.reducer');

var _multitrack = require('helpers/multitrack');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(rateVideoRequest),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(doUpdateVideoFilter),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(doUpdateVideoList),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(doLoadOnDemandVideos),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(doLoadVideoCollection),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(doLoadVideos),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(doLoadVideoStacks),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(doLoadUpcomingVideos),
    _marked9 = /*#__PURE__*/_regenerator2.default.mark(doRateVideo),
    _marked10 = /*#__PURE__*/_regenerator2.default.mark(watchVideos),
    _marked11 = /*#__PURE__*/_regenerator2.default.mark(watchOnDemandVideos),
    _marked12 = /*#__PURE__*/_regenerator2.default.mark(watchVideoCollection),
    _marked13 = /*#__PURE__*/_regenerator2.default.mark(watchLoadUpcomingVideos),
    _marked14 = /*#__PURE__*/_regenerator2.default.mark(watchLoadVideos),
    _marked15 = /*#__PURE__*/_regenerator2.default.mark(watchUpdateVideoList);

var LOAD_VIDEO_STACKS = exports.LOAD_VIDEO_STACKS = 'LOAD_VIDEO_STACKS';
var LOAD_UPCOMING_VIDEOS = exports.LOAD_UPCOMING_VIDEOS = 'LOAD_UPCOMING_VIDEOS';
var LOAD_VIDEOS = exports.LOAD_VIDEOS = 'LOAD_VIDEOS';
var RATE_VIDEO = exports.RATE_VIDEO = 'RATE_VIDEO';
var LOAD_ONDEMAND_VIDEOS = exports.LOAD_ONDEMAND_VIDEOS = 'LOAD_ONDEMAND_VIDEOS';
var LOAD_VIDEO_COLLECTION = exports.LOAD_VIDEO_COLLECTION = 'LOAD_VIDEO_COLLECTION';
var LOAD_VIDEO_ERROR = exports.LOAD_VIDEO_ERROR = 'LOAD_VIDEO_ERROR';
var UPDATE_VIDEO_FILTER = exports.UPDATE_VIDEO_FILTER = 'UPDATE_VIDEO_FILTER';
var UPDATE_VIDEO_LIST = exports.UPDATE_VIDEO_LIST = 'UPDATE_VIDEO_LIST';

var FILTERSET_NAME = exports.FILTERSET_NAME = 'videos';
var filterActions = exports.filterActions = (0, _filtersets.actionsForFilterSet)(FILTERSET_NAME);

var loadVideos = exports.loadVideos = function loadVideos(params, options) {
  return { type: LOAD_VIDEOS, params: params, options: options };
};
var loadOnDemandVideos = exports.loadOnDemandVideos = function loadOnDemandVideos() {
  return { type: LOAD_ONDEMAND_VIDEOS };
};
var loadVideoCollection = exports.loadVideoCollection = function loadVideoCollection(collectionId) {
  return { type: LOAD_VIDEO_COLLECTION, collectionId: collectionId };
};
var loadVideoStacks = exports.loadVideoStacks = function loadVideoStacks() {
  return { type: LOAD_VIDEO_STACKS };
};
var loadUpcomingVideos = exports.loadUpcomingVideos = function loadUpcomingVideos() {
  return { type: LOAD_UPCOMING_VIDEOS };
};
var rateVideo = exports.rateVideo = function rateVideo(userId, payload) {
  return { type: RATE_VIDEO, userId: userId, payload: payload };
};
var updateVideoFilter = exports.updateVideoFilter = function updateVideoFilter(filter, option) {
  return { type: UPDATE_VIDEO_FILTER, filter: filter, option: option };
};
var updateVideoList = exports.updateVideoList = function updateVideoList() {
  return { type: UPDATE_VIDEO_LIST };
};
var loadVideoError = exports.loadVideoError = _helpers.errorActionCreator.bind(null, LOAD_VIDEO_ERROR);

function rateVideoRequest(client, userId, payload) {
  return _regenerator2.default.wrap(function rateVideoRequest$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return client.videos.createVideoViewRating(userId, payload);

        case 2:
          return _context.abrupt('return', _context.sent);

        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function onModalClose() {
  return false;
}

function doUpdateVideoFilter(client, _ref) {
  var filter = _ref.filter,
      option = _ref.option;

  var _ref2, _ref3, query, pathname;

  return _regenerator2.default.wrap(function doUpdateVideoFilter$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;

          if (!option) {
            _context2.next = 6;
            break;
          }

          _context2.next = 4;
          return (0, _effects.put)(filterActions.toggleItemId(filter, [option]));

        case 4:
          _context2.next = 13;
          break;

        case 6:
          if (!filter) {
            _context2.next = 11;
            break;
          }

          _context2.next = 9;
          return (0, _effects.put)(filterActions.clearFilter(filter));

        case 9:
          _context2.next = 13;
          break;

        case 11:
          _context2.next = 13;
          return (0, _effects.put)(filterActions.clearFilterSet());

        case 13:
          _context2.next = 15;
          return (0, _effects.all)([(0, _effects.select)(_filters.createQuerystringFromFilters, FILTERSET_NAME), (0, _effects.select)(_selectors.pathSelector)]);

        case 15:
          _ref2 = _context2.sent;
          _ref3 = (0, _slicedToArray3.default)(_ref2, 2);
          query = _ref3[0];
          pathname = _ref3[1];
          _context2.next = 21;
          return (0, _effects.put)((0, _reactRouterRedux.push)({
            pathname: pathname,
            query: query
          }));

        case 21:
          _context2.next = 27;
          break;

        case 23:
          _context2.prev = 23;
          _context2.t0 = _context2['catch'](0);
          _context2.next = 27;
          return (0, _effects.put)(loadVideoError(_context2.t0));

        case 27:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 23]]);
}

function doUpdateVideoList(client) {
  var user, _ref4, _ref5, permissions, reduxFilters, filters, filterOptions, res;

  return _regenerator2.default.wrap(function doUpdateVideoList$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 3:
          user = _context3.sent;
          _context3.next = 6;
          return (0, _effects.all)([(0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userPermissions, [client, user.id]), (0, _effects.call)(_filters.writeFiltersFromQuerystring, filterActions, FILTERSET_NAME)]);

        case 6:
          _ref4 = _context3.sent;
          _ref5 = (0, _slicedToArray3.default)(_ref4, 1);
          permissions = _ref5[0];
          _context3.next = 11;
          return (0, _effects.select)(_selectors.filterSetFilters, FILTERSET_NAME);

        case 11:
          reduxFilters = _context3.sent;
          filters = (0, _keys2.default)(reduxFilters).reduce(function (acc, filter) {
            if (reduxFilters[filter].countSelected > 0) {
              acc[filter] = (0, _keys2.default)(reduxFilters[filter].itemIdSelected);
            }
            return acc;
          }, {});
          filterOptions = (0, _extends3.default)({}, filters, {
            cp_home_beta: permissions.feature_videos_live_tests || false
          });
          _context3.next = 16;
          return (0, _effects.call)(_sagaTools.fetchEntity, _bound.videos, [client, filterOptions]);

        case 16:
          res = _context3.sent;
          _context3.next = 19;
          return (0, _effects.call)(_multitrack.ec, 'Video Search', {
            filters_applied: (0, _keys2.default)(filters).filter(function (k) {
              return reduxFilters[k].countSelected > 0;
            }),
            activity: filters.activities,
            duration_bucket: filters.durations,
            studio_selected: filters.partners,
            number_results: res.length
          });

        case 19:
          _context3.next = 25;
          break;

        case 21:
          _context3.prev = 21;
          _context3.t0 = _context3['catch'](0);
          _context3.next = 25;
          return (0, _effects.put)(loadVideoError(_context3.t0));

        case 25:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[0, 21]]);
}

function doLoadOnDemandVideos(client) {
  return _regenerator2.default.wrap(function doLoadOnDemandVideos$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.onDemandVideos, [client]);

        case 3:
          _context4.next = 9;
          break;

        case 5:
          _context4.prev = 5;
          _context4.t0 = _context4['catch'](0);
          _context4.next = 9;
          return (0, _effects.put)(loadVideoError(_context4.t0));

        case 9:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[0, 5]]);
}

function doLoadVideoCollection(client, _ref6) {
  var collectionId = _ref6.collectionId;
  return _regenerator2.default.wrap(function doLoadVideoCollection$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.videoCollection, [client, 'curated', collectionId]);

        case 3:
          _context5.next = 9;
          break;

        case 5:
          _context5.prev = 5;
          _context5.t0 = _context5['catch'](0);
          _context5.next = 9;
          return (0, _effects.put)(loadVideoError(_context5.t0));

        case 9:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this, [[0, 5]]);
}

function doLoadVideos(client) {
  var filters, populateFilters;
  return _regenerator2.default.wrap(function doLoadVideos$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.videosFilters, [client, { app: 'web' }]);

        case 3:
          filters = _context6.sent;

          // populate filters
          populateFilters = filters.map(function (filter) {
            return (0, _effects.put)(filterActions.addFilter(filter.ref, filter.options.map(function (option) {
              return { id: option.ref };
            })));
          });
          _context6.next = 7;
          return (0, _effects.all)([].concat((0, _toConsumableArray3.default)(populateFilters), [(0, _effects.call)(doUpdateVideoList, client)]));

        case 7:
          _context6.next = 13;
          break;

        case 9:
          _context6.prev = 9;
          _context6.t0 = _context6['catch'](0);
          _context6.next = 13;
          return (0, _effects.put)(loadVideoError(_context6.t0));

        case 13:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this, [[0, 9]]);
}

function doLoadVideoStacks(client) {
  var user, _ref7, _ref8, permissions, subscription, options, clientTimeZone, pending, ratingCookie, exceedsLimit;

  return _regenerator2.default.wrap(function doLoadVideoStacks$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 3:
          user = _context7.sent;
          _context7.next = 6;
          return (0, _effects.all)([(0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userPermissions, [client, user.id]), (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.liveSubscription, [client])]);

        case 6:
          _ref7 = _context7.sent;
          _ref8 = (0, _slicedToArray3.default)(_ref7, 2);
          permissions = _ref8[0];
          subscription = _ref8[1];
          options = { platform: 'web' };
          clientTimeZone = global.Intl.DateTimeFormat().resolvedOptions().timeZone;


          if (permissions.feature_videos_live_tests) {
            options.cp_home_beta = 1;
            options.top_users = 1;
          } // TODO: handle unpermissioned flow
          if (clientTimeZone) {
            options.timezone_name = clientTimeZone;
          }
          _context7.next = 16;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.videoStacks, [client, options]);

        case 16:
          _context7.next = 18;
          return (0, _effects.call)(_sagaTools.fetchEntity, _bound.videoViewRatings, [client, user.id]);

        case 18:
          pending = _context7.sent;


          // Modal can only display a maximum of 5 times per browser session
          ratingCookie = _cookie2.default.parse(document.cookie).rating_modal_count || 0;
          exceedsLimit = ratingCookie && parseInt(ratingCookie, 10) >= _video.RATINGS_MODAL_MAX_SHOW;

          if (!(pending.length > 0 && !exceedsLimit)) {
            _context7.next = 24;
            break;
          }

          _context7.next = 24;
          return (0, _effects.put)((0, _modals.showModal)('VideosRatingsModal', {
            userId: user.id,
            onModalClose: onModalClose
          }));

        case 24:
          if (!_Subscription2.default.isFreemium(subscription.data)) {
            _context7.next = 27;
            break;
          }

          _context7.next = 27;
          return (0, _effects.put)((0, _Banners.addGenericNotification)('NEW! For a limited time, you have complimentary access to ClassPass Live - streaming HIIT workouts you can do anywhere.', {
            timeout: 0
          }));

        case 27:
          _context7.next = 33;
          break;

        case 29:
          _context7.prev = 29;
          _context7.t0 = _context7['catch'](0);
          _context7.next = 33;
          return (0, _effects.put)(loadVideoError(_context7.t0));

        case 33:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this, [[0, 29]]);
}

function doLoadUpcomingVideos(client) {
  return _regenerator2.default.wrap(function doLoadUpcomingVideos$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.liveVideos, [client, { upcoming: 1 }]);

        case 3:
          _context8.next = 9;
          break;

        case 5:
          _context8.prev = 5;
          _context8.t0 = _context8['catch'](0);
          _context8.next = 9;
          return (0, _effects.put)(loadVideoError(_context8.t0));

        case 9:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this, [[0, 5]]);
}

function doRateVideo(client, _ref9) {
  var userId = _ref9.userId,
      payload = _ref9.payload;
  var pending, ratingCookie;
  return _regenerator2.default.wrap(function doRateVideo$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.prev = 0;
          _context9.next = 3;
          return (0, _effects.call)(rateVideoRequest, client, userId, payload);

        case 3:
          _context9.next = 5;
          return (0, _effects.call)(_sagaTools.fetchEntity, _bound.videoViewRatings, [client, userId]);

        case 5:
          pending = _context9.sent;

          if (!(pending.length === 0)) {
            _context9.next = 9;
            break;
          }

          _context9.next = 9;
          return (0, _effects.put)((0, _modals.hideModal)('VideosRatingsModal'));

        case 9:
          _context9.next = 11;
          return (0, _effects.put)((0, _rating.resetRating)());

        case 11:
          _context9.next = 22;
          break;

        case 13:
          _context9.prev = 13;
          _context9.t0 = _context9['catch'](0);
          ratingCookie = _cookie2.default.parse(document.cookie).rating_modal_count || 0;

          if (!(parseInt(ratingCookie, 10) >= _video.RATINGS_MODAL_MAX_SHOW)) {
            _context9.next = 21;
            break;
          }

          _context9.next = 19;
          return (0, _effects.put)((0, _modals.hideModal)('VideosRatingsModal'));

        case 19:
          _context9.next = 22;
          break;

        case 21:
          document.cookie = 'rating_modal_count=' + (parseInt(ratingCookie, 10) + 1);

        case 22:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this, [[0, 13]]);
}

function watchVideos(client) {
  return _regenerator2.default.wrap(function watchVideos$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, LOAD_VIDEO_STACKS, doLoadVideoStacks, client);

        case 2:
          _context10.next = 4;
          return (0, _effects.fork)(_effects.takeEvery, RATE_VIDEO, doRateVideo, client);

        case 4:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function watchOnDemandVideos(client) {
  return _regenerator2.default.wrap(function watchOnDemandVideos$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, LOAD_ONDEMAND_VIDEOS, doLoadOnDemandVideos, client);

        case 2:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function watchVideoCollection(client) {
  return _regenerator2.default.wrap(function watchVideoCollection$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, LOAD_VIDEO_COLLECTION, doLoadVideoCollection, client);

        case 2:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function watchLoadUpcomingVideos(client) {
  return _regenerator2.default.wrap(function watchLoadUpcomingVideos$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, LOAD_UPCOMING_VIDEOS, doLoadUpcomingVideos, client);

        case 2:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

function watchLoadVideos(client) {
  return _regenerator2.default.wrap(function watchLoadVideos$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, LOAD_VIDEOS, doLoadVideos, client);

        case 2:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}

function watchUpdateVideoList(client) {
  return _regenerator2.default.wrap(function watchUpdateVideoList$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, UPDATE_VIDEO_LIST, doUpdateVideoList, client);

        case 2:
          _context15.next = 4;
          return (0, _effects.fork)(_effects.takeEvery, UPDATE_VIDEO_FILTER, doUpdateVideoFilter, client);

        case 4:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this);
}